import Button from "../../../../componentes/button/button";

/**
 * Tela da etapa 1 quando a solicitação volta para lá por um RETIFICAR (não é a criação — essa
 * acontece antes de existir uma Solicitação). Não há hoje endpoint para editar os campos da
 * etapa 1 de uma solicitação já existente, então mostramos os dados atuais (no cabeçalho/detalhe
 * da página) como estão e permitimos reenviar. Quem vai receber a etapa 2 é decidido no Sidebar
 * de encaminhamento (acionado por onExecutarAcao), não aqui.
 */
export default function EtapaSolicitacaoRetificada({ acoes = [], acaoEmExecucao, onExecutarAcao }) {
    const podeEnviar = acoes.includes("ENVIAR");

    return (
        <div className="flex flex-col gap-4">
            <p className="text-sm text-muted-foreground">
                Esta solicitação está na etapa inicial (foi retificada ou ainda não foi enviada). A edição dos campos
                originais ainda não está disponível nesta versão — confira os anexos e reenvie para seguir o fluxo com os dados atuais.
            </p>

            <div className="flex justify-end">
                {podeEnviar && (
                    <Button
                        variant="blue"
                        label="Reenviar"
                        iconLeft="fa fa-paper-plane"
                        loading={acaoEmExecucao === "ENVIAR"}
                        onClick={() => onExecutarAcao("ENVIAR", {})}
                    />
                )}
            </div>
        </div>
    );
}
